import { render } from "./Hero75.vue?vue&type=template&id=ba9b56d6&scoped=true"
import script from "./Hero75.vue?vue&type=script&lang=js"
export * from "./Hero75.vue?vue&type=script&lang=js"

import "./Hero75.vue?vue&type=style&index=0&id=ba9b56d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ba9b56d6"

export default script